<!-- ACR&零件事故报告书 -->
<template xmlns="http://www.w3.org/1999/html">
	<el-dialog :visible.sync="visible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" class="data-dialog" width="1200px">
		<span slot="title" class="dialog-title">
			<img src="@/assets/images/close.png" alt="" @click="visible = false" />
		</span>
		<button class="el-button down-btn menu-btn el-button--primary" @click="handlePdf()">下载</button>
		<div class="mrt-content" ref="pdfcontent">
			<h1>零件事故报告书</h1>
			<div class="sub-title">
				<h3>编号：{{ form.serialNumber }}</h3>
				<h3 class="mb5">（推荐电脑编辑后打印）</h3>
			</div>
			<table class="table-border">
				<tr>
					<template>
						<div class="tr-header_left">
							<div class="tr-header_left-span">
								<div class="tr-header_left-span_type">
									<span>事故类型：</span>
									<div class="tr-header_left-span_type-sel">
										<span>[{{ form.partsClaimOrders.issueType == 1 ? " ✓" : "" }} ] 开箱不良 (ACR)</span>
										<span>[{{ form.partsClaimOrders.issueType == 2 ? " ✓" : "" }} ] 品质事故 (ACR)</span>
									</div>
								</div>
								<span>事故管理编号 (CSPC填写)：</span>
							</div>
							<div class="tr-header_rigth">
								注意：（发货15个工作日内提交，包装损坏签收单注明）
								<br />
								注意：（理光出库后90天以内，且非安装或使用不当造成）
								<br />
								<span class="tr-header_rigth-font">具体索赔规则参考索赔申请系统！！！</span>
								<br />
								联系人:周静 电话：021-52380222*8692 直线:021-23102822
								<br />
								邮箱：jing.zhou@cn.ricoh.com
							</div>
						</div>
					</template>
				</tr>
			</table>
			<h2 style="font-size: 17px" class="mt10">由经销商填写（并加盖公章）：</h2>
			<table class="table-box_no-bottom">
				<tr class="tr-height-200">
					<template>
						<div class="tr-notable-box">
							<div class="box_1">
								<div>
									<p>公司名称：</p>
									<p class="mt10">事故内容：</p>
									<p class="mt5" style="font-size: 14px">（必须选择）</p>
								</div>
								<div>事故品明细：</div>
							</div>
							<div style="display: flex; flex-direction: column; width: 100%">
								<div style="display: flex; width: 100%">
									<p style="text-decoration: underline">{{ form.applyOrgName }}</p>
									<div style="margin-left: 200px; display: flex">
										事故发现日期：
										<p style="text-decoration: underline">
											{{ form.partsClaimOrders.issueDate.replace(/(\d{4})-(\d{2})-(\d{2})/, "$1年$2月$3日") }}
										</p>
									</div>
								</div>
								<div style="display: flex; width: 100%">
									<div class="box_2">
										<p class="mt10">
											[{{ form.partsClaimOrders.issueType == 1 && form.partsClaimOrders.issueDetails == 1 ? " ✓" : "" }} ] 开箱损坏
											(外包装完好，未使用)
										</p>
										<p class="mt10">
											[{{ form.partsClaimOrders.issueType == 1 && form.partsClaimOrders.issueDetails == 2 ? " ✓" : "" }} ] 物流损坏
											(拒收、签收注明)
										</p>
										<p class="mt10">
											[{{ form.partsClaimOrders.issueType == 1 && form.partsClaimOrders.issueDetails == 3 ? " ✓" : "" }} ] 不足
											(实收数量少于装箱单数量)
										</p>
										<p class="mt10">
											[{{ form.partsClaimOrders.issueType == 1 && form.partsClaimOrders.issueDetails == 4 ? " ✓" : "" }} ] 过剩
											(实收数量大于装箱单数量)
										</p>
									</div>
									<div class="box_3">
										<p class="mt10">
											[{{ form.partsClaimOrders.issueType == 1 && form.partsClaimOrders.issueDetails == 5 ? " ✓" : "" }} ] 发错
											(实收品与装箱单明细不符)
										</p>
										<p class="mt10">
											[{{ form.partsClaimOrders.issueType == 1 && form.partsClaimOrders.issueDetails == 6 ? " ✓" : "" }} ] 遗漏
											(未收到装箱单上货品)
										</p>
										<p class="mt10">
											[{{ form.partsClaimOrders.issueType == 1 && form.partsClaimOrders.issueDetails == 7 ? " ✓" : "" }} ] 其它
										</p>
									</div>
								</div>
							</div>
						</div>
					</template>
				</tr>
			</table>
			<table class="table-box_hairy">
				<tr>
					<th style="width: 5%">序号</th>
					<th style="width: 20%">部品编号</th>
					<th style="width: 8%">数量</th>
					<th style="width: 20%">订单号</th>
					<th style="width: 20%">装箱单号</th>
					<th>备注</th>
				</tr>
				<tr v-for="(item, i) in partsDetailList" :key="i">
					<td style="width: 5%">{{ i + 1 }}、</td>
					<td style="width: 20%">{{ item.partsNumber }}</td>
					<td style="width: 8%">{{ item.partsAmount }}</td>
					<td style="width: 20%">{{ item.partsAmount ? form.partsClaimOrders.orderNumber : "" }}</td>
					<td style="width: 20%">{{ item.partsAmount ? form.partsClaimOrders.packingSlipNumber : "" }}</td>
					<td>{{ item.partsTest == null ? "" : partsTests[item.partsTest] }}</td>
				</tr>
			</table>
			<table class="table-box">
				<tr>
					<template>
						<div class="tr_box1">
							<div class="tr_box-left">
								<div class="tr_box-p">情况说明</div>
								<div class="opinion-content">{{ form.partsClaimOrders.situationDescription }}</div>
							</div>
							<div class="tr_box-right">
								<table>
									<tr>
										<td style="width: 28%">报告人</td>
										<td>联系电话</td>
										<td style="width: 28%">日期</td>
									</tr>
									<tr class="tr-height-60">
										<td>{{ form.createUsrNamePhone ? form.createUsrNamePhone.split("/")[0] : "" }}</td>
										<td>{{ form.createUsrNamePhone ? form.createUsrNamePhone.split("/")[1] : "" }}</td>
										<td>{{ form.createTime.substring(0, 10).replaceAll("-", "/") }}</td>
									</tr>
								</table>
							</div>
						</div>
					</template>
				</tr>
			</table>
			<table class="table-box">
				<tr class="tr-height-200">
					<template>
						<div class="tr_box">
							<div class="tr_box-left">
								<p class="pa5">技术鉴定部门填写：（鉴定意见及赔偿结果）</p>
								<div class="opinion-content">{{ audit1.remark }}</div>
							</div>
							<div class="tr_box-right">
								<table>
									<tr>
										<td>担当</td>
										<td>管理者</td>
										<td>日期</td>
									</tr>
									<tr class="tr-height-60">
										<td>{{ audit1.createName }}</td>
										<td></td>
										<td>{{ audit1.createTime.substring(0, 10).replaceAll("-", "/") }}</td>
									</tr>
								</table>
							</div>
						</div>
					</template>
				</tr>
			</table>
			<table class="table-box">
				<tr class="tr-height-150">
					<template>
						<div class="tr_box" style="height: 150px">
							<div class="tr_box-left">
								<p class="pa5">业务统括部订单科填写：（索赔订单受理内容）</p>
								<div class="opinion-content">{{ audit2.remark }}</div>
							</div>
							<div class="tr_box-right">
								<table>
									<tr>
										<td>担当</td>
										<td>管理者</td>
										<td>日期</td>
									</tr>
									<tr class="tr-height-60">
										<td>{{ audit2.createName }}</td>
										<td></td>
										<td>{{ audit2.createTime.substring(0, 10).replaceAll("-", "/") }}</td>
									</tr>
								</table>
							</div>
						</div>
					</template>
				</tr>
			</table>
			<div>
				<h3>零件损坏照片发至相关担当,电话:021-52380222-分机。</h3>
				<h3 style="color: red" class="mt5">损坏零件退回前，请先与担当联系，将事故零件、损坏点、包装、外箱的照片发送邮件。</h3>
				<h3 style="color: red">我们会指定物流上门提货，不接受运费到付！（否则退回不予签收）</h3>
			</div>
		</div>
	</el-dialog>
</template>
<script>
import JsPDF from "jspdf";
import html2Canvas from "html2canvas";

export default {
	data() {
		return {
			visible: false,
			form: {
				createTime: "",
				createUsrNamePhone: "",
				submitTime: "",
				serialNumber: "",
				repairType: "2", // 索赔的类型 1、保修期内机器零件故障 2、理光单独订购零件 3、商品（耗材故障）
				applyOrgType: "", // 申请方信息-机构类型 1、网络店 2、特约维修店 3、代理商 4、分部
				applyOrgId: "", // 申请方信息 对应的机构id
				repairModelId: "", // 机型及开发名 一级
				repairDeviceId: "", // 机型及开发名 二级
				repairDeviceNumber: "", // 机号
				//基本信息
				partsClaimOrders: {
					issueDate: "", // 问题发生日
					orderNumber: "", // 订单号
					packingSlipNumber: "", // 装箱单号
					situationDescription: "", // 情况说明
					additionalNotes: "", // 补充说明栏
					issueType: "", // 事故类型 1、开箱不良 2、品质事故
					issueDetails: "", // 事故内容勾选 1、开箱损坏 2、物流损坏 3、数量不足 4、数量过剩 5、发错 6、遗漏 7、其他
				},
			},
			partsDetailList: [],
			// 技术鉴定部门填写
			audit1: {
				createTime: "",
				createName: "",
				remark: "",
			},
			// 业务统括部订单科填写
			audit2: {
				createTime: "",
				createName: "",
				remark: "",
			},
			partsTests: {
				1: "正常",
				2: "故障",
			},
		};
	},
	methods: {
		init(data) {
			this.visible = true;
			this.$nextTick(() => {
				setTimeout(() => {
					this.form = data.form;
					console.log(this.form);
					// 零件补齐5个
					let oldNum = data.partsDetailLists ? data.partsDetailLists.length : data.form.partsDetailList.length;
					let fillNum = 5 - oldNum;
					let fillArray = data.partsDetailLists
						? JSON.parse(JSON.stringify(data.partsDetailLists))
						: JSON.parse(JSON.stringify(data.form.partsDetailList));
					if (fillNum > 0) {
						for (let index = 0; index < fillNum; index++) {
							fillArray.push({
								partsName: "",
								partsNumber: "",
								partsAmount: "",
							});
						}
					}
					this.partsDetailList = fillArray;
					if (this.form.hisAudit) {
						for (const element of this.form.hisAudit) {
							// 测试部
							if (element.auditStatus == 27) {
								this.audit1 = element;
							}
							// 订单科
							if ([21, 23, 24].includes(element.auditStatus)) {
								this.audit2 = element;
							}
							if ([30].includes(element.auditStatus)) {
								this.audit2 = element;
							}
						}
					}
					data.auditRemarks ? (this.audit2.remark = data.auditRemarks) : "";
				}, 50);
			});
		},
		// pdf下载
		handlePdf() {
			const title = "零件事故报告书_" + new Date().getTime();
			const opts = {
				scale: window.devicePixelRatio * 3,
				dpi: window.devicePixelRatio * 4,
				allowTaint: true,
				useCORS: true,
			};
			let that = this;
			html2Canvas(this.$refs.pdfcontent, opts).then(function (canvas) {
				let imgWidth = 595.28;
				let imgHeight = 860;
				let pageData = canvas.toDataURL("image/jpeg", 1.0);
				let PDF = new JsPDF("", "pt", "a4");
				PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
				PDF.save(title + ".pdf");
				that.visible = false;
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.data-dialog /deep/ .el-dialog {
	border-radius: 10px !important;
}

.data-dialog /deep/ .el-dialog__body {
	padding: 0 20px !important;
}

.data-dialog .dialog-title {
	display: block;
	text-align: center;

	span {
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}

	img {
		width: 28px;
		float: right;
		cursor: pointer;
	}
}

.mrt-content {
	padding: 80px 60px;
	background-color: white;
	color: black;

	h1 {
		font-size: 28px;
		font-weight: normal;
		text-align: center;
		margin-bottom: 15px;
		color: black;
	}

	table {
		width: 100%;
		border-collapse: collapse;
		font-size: 16px;
		font-weight: normal;
		color: black;
		//margin-bottom: 15px;
	}

	.table-border {
		border: 3px solid black;
	}

	.table-box {
		border-right: 3px solid black;
		border-left: 3px solid black;
		border-bottom: 3px solid black;
	}

	.table-box_hairy {
		border-right: 3px solid black;
		border-left: 3px solid black;
		border-bottom: 1px solid black;
	}

	.table-box_no-bottom {
		border-right: 3px solid black;
		border-left: 3px solid black;
		border-top: 3px solid black;
	}

	.table-box_top_left {
		border-left: 1px solid black;
		border-top: 1px solid black;
		height: 100px;
	}

	th,
	td {
		border: 1.1px solid black;
	}

	th,
	td {
		font-weight: normal;
		padding: 6px;
		background-color: white;
		text-align: center;
		white-space: normal;
		word-wrap: break-word;
	}

	tr {
		height: 40px;
	}

	td {
		width: 150px;
	}

	.sub-title {
		display: flex;
		justify-content: space-between;
	}

	.tr-header_left {
		display: flex;
		justify-content: space-between;
		width: 100%;
		height: 100%;
		padding: 10px;
		box-sizing: border-box;

		.tr-header_left-span {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			text-align: left;
			flex: 0.6;

			.tr-header_left-span_type {
				display: flex;
				justify-content: space-between;

				.tr-header_left-span_type-sel {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					line-height: 26px;
				}
			}
		}

		.tr-header_rigth {
			width: 55%;
			min-height: 100%;
			line-height: 30px;
			color: red;
			font-weight: bolder;

			.tr-header_rigth-font {
				color: black;
				font-style: italic;
			}
		}
	}

	.tr-height-60 {
		height: 60px;
	}

	.tr-height-80 {
		height: 80px;
	}

	.tr-height-100 {
		height: 100px;
	}

	.tr-height-150 {
		height: 150px;
	}

	.tr-height-200 {
		height: 200px;
	}

	.th-title-left {
		text-align: left;
	}

	.th-title-left_top {
		text-align: left;
		vertical-align: top;
	}

	.td-text-center {
		text-align: center;
		vertical-align: center;
	}

	.th-inst {
		text-align: left;
		white-space: normal;
		word-wrap: break-word;
	}

	.opinion {
		display: flex;
		justify-content: space-between;

		.opinion-date {
			border-bottom: 1px solid black;
			border-right: 1px solid black;
			height: 30px;
			width: 100%;
			line-height: 30px;
			text-align: center;
		}
	}

	.opinion-top {
		height: 30px;
		width: 460px;
	}

	.opinion-bottom {
		width: 460px;
		height: 100px;
		position: absolute;
		right: 82px;
		bottom: 98px;
	}

	.tr_box {
		display: flex;
		justify-content: space-between;
		width: 100%;
		height: 200px;

		.tr_box-left {
			display: flex;
			flex-direction: column;
			width: 100%;
			height: 100%;
			box-sizing: border-box;
		}

		.tr_box-right {
			width: 460px;
			height: 100%;
			display: flex;
			align-items: flex-end;
		}

		.opinion-content {
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 5px;
			box-sizing: border-box;
		}
	}

	.tr_box1 {
		display: flex;
		justify-content: space-between;
		width: 100%;
		height: 150px;

		.tr_box-left {
			display: flex;
			flex-direction: column;
			width: 100%;
			height: 100%;
			box-sizing: border-box;

			.tr_box-p {
				width: 100px;
				border-right: 1px solid black;
				border-bottom: 1px solid black;
				align-items: center;
				text-align: center;
			}
		}

		.tr_box-right {
			width: 800px;
			height: 100%;
			display: flex;
			align-items: flex-end;
		}

		.opinion-content {
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 5px;
			box-sizing: border-box;
		}
	}

	.tr-notable-box {
		width: 100%;
		height: 200px;
		padding: 5px;
		display: flex;
		flex-direction: row;

		.box_1 {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			width: 120px;
			height: 100%;
		}
		.box_2 {
			width: 100%;
			text-align: left;
			margin-left: 15px;
		}
		.box_3 {
			width: 100%;
			text-align: left;
			margin-left: 0;
		}
	}
}
</style>
